import Service from "../../AuthService";
const factoryEmployeeImport = {
    getFactoryEmployeeImport(page,data){
        return Service.get(`factory_employee_import?page=${page}` +
            `&factory_id=${data.factory_id}` +
            `&start_date=${data.start_date}` +
            `&end_date=${data.end_date}` +
            `&employee_id=${data.employee_id}`+
            `&pdf=${data.pdf}`
        );
    },
    showFactoryEmployeeImport(id){
        return Service.get('/factory_employee_import/'+id);
    },
    createFactoryEmployeeImport(data){
        return Service.post('/factory_employee_import',data);
    },
    updateFactoryEmployeeImport(id,data){
        return Service.put('/factory_employee_import/'+id,data);
    },
    deleteFactoryEmployeeImport(id){
        return Service.delete('/factory_employee_import/'+id);
    },
    accept(data){
        return Service.get('/factory_employee_import_accept?id='+data.id+'&user='+data.user_id);
    },
}
export default factoryEmployeeImport
